export default {"src":"/_next/static/media/bedrock.ee97a32f.svg","height":30,"width":100,"blurWidth":0,"blurHeight":0};